import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

export interface EmbeddedAuthState {
  kind: 'idle' | 'code-exchange-failed' | 'session-expired';
}

@Injectable( {
  providedIn: 'root'
} )
export class EmbeddedContextService {
  private embeddedAuthStateSubject = new BehaviorSubject<EmbeddedAuthState>( { kind: 'idle' } );
  private embeddedRunMetadataRefreshSubject = new Subject<string>();

  embeddedAuthState$ = this.embeddedAuthStateSubject.asObservable();
  embeddedRunMetadataRefresh$ = this.embeddedRunMetadataRefreshSubject.asObservable();

  constructor( private readonly router: Router ) {}

  isEmbeddedRoute( url: string = this.router.url ): boolean {
    return true;
  }

  setCodeExchangeFailed(): void {
    this.embeddedAuthStateSubject.next( { kind: 'code-exchange-failed' } );
  }

  setSessionExpired(): void {
    this.embeddedAuthStateSubject.next( { kind: 'session-expired' } );
  }

  clearEmbeddedAuthState(): void {
    this.embeddedAuthStateSubject.next( { kind: 'idle' } );
  }

  requestEmbeddedRunMetadataRefresh( runId: string ): void {
    this.embeddedRunMetadataRefreshSubject.next( runId );
  }
}